/* ROUTERS  */
export const ROUTES = {
  MAIN: "/",
  LOGOUT: "/logout",
  LOGIN: "/login",
  AUTHENTICATION: "/authentication",
};

/*  Modules */
export const MODULES = {
  USERS: "Users",
  LOGOUT: "Logout",
};

/* Authentication */
export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';

export const ERROR_PAGE_TITLE = "Oops! An error occurred!";
export const ERROR_PAGE_SUBTITLE =
  "Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.";
